import { Spinner } from "@material-tailwind/react";
import "../styles/spinner.css"

function LoadingSpinner(){
    return (
        <div className="spinner-wrapper">
            <Spinner className="h-12 w-12" color="orange"/>
        </div>
    )    
}

export default LoadingSpinner;
